var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var ErrorMessage = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  font-size: 0.6875rem;\n  color: ", ";\n"], ["\n  margin: 0;\n  font-size: 0.6875rem;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.bpCore.colors.error;
});
var templateObject_1;
